import { controls } from "../../controls";

const rp1010 = {
  label: "MOU 10",
  pageLabel: "MOU 10",
  starting: true,
  url: "rp1010",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As On Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"As On Date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({tab: "filter",label: "As On Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"As On Date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({tab: "filter",label: "As On Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"As On Date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "STATEMENT NO.10 SUSTAINABLE VIABILITY",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "YEARS",
        accessor: "years_code",
        width: 80,
        rwidth: 50
      },
      {
        Header: "Working Fund Rs.",
        accessor: "working_fund_rs_code",
        type:"currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Owned Fund Share capital & reserves with NPA Prov.Rs",
        accessor: "owned_fund_share_reserves_with_npa_code",
        type:"currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "% to W/F",
        accessor: "percentagetowf_code",
        type:"currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Deposit Rs.",
        accessor: "deposit_code",
        type:"currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "% to W/F",
        accessor: "percentagetowf_code",
        type:"currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Borrowing Rs.",
        accessor: "borrowing_rs_code",
        type:"currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "% to W/F",
        accessor: "percentagetowf_code",
        type:"currency",
        width: "*",
        rwidth: "*"
      },
            
    ]
  }
};

export default rp1010;